import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import GraphicContentBlock from '../GraphicContentBlock';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) => colourOverrideBackground || themeGet('colors.neutral_2')};

  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${({ colourOverrideText }) => colourOverrideText || themeGet('colors.neutral_3')};
  }
  &.large-image {
    background-color: ${({ colourOverrideBackground }) => colourOverrideBackground || themeGet('colors.neutral_1')};
  }

  &.single-item {
  }
`;

export const GraphicBlock = styled(GraphicContentBlock)`
  margin: 25px 0;

  ${Wrapper}.large-image & {
    margin: 40px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 35px 0;

    p {
      max-width: 550px;
    }

    ${Wrapper}.large-image & {
      &:nth-child(even) {
        margin-top: 0;
      }

      margin: 48px 0;
    }

    ${Wrapper}.single-item & {
      margin: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin: 20px 0;

    p {
      max-width: 650px;
    }
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 50px 0 60px;

  /* Title */
  > h1:first-child,
  > h2:first-child,
  > h3:first-child,
  > h4:first-child,
  > h5:first-child,
  > h6:first-child,
  > p:first-child {
    color: ${themeGet('colors.text-secondary')};
    text-align: center;
    margin-bottom: 45px;
  }

  /* Subtitle */
  h1:nth-child(2n),
  h2:nth-child(2n),
  h3:nth-child(2n),
  h4:nth-child(2n),
  h5:nth-child(2n),
  h6:nth-child(2n) {
    color: ${themeGet('colors.secondary')};
    font-weight: 500;
    text-align: left;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 25px;
  }

  ${GraphicBlock} {
    &:first-of-type {
      margin-top: 0;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  ${Wrapper}.large-image & {
    /* Title */
    > h1:first-child,
    > h2:first-child,
    > h3:first-child,
    > h4:first-child,
    > h5:first-child,
    > h6:first-child,
    > p:first-child {
      margin-bottom: 30px;
    }

    /* Subtitle */
    h1:nth-child(2n),
    h2:nth-child(2n),
    h3:nth-child(2n),
    h4:nth-child(2n),
    h5:nth-child(2n),
    h6:nth-child(2n) {
      margin-bottom: 30px;
      color: ${themeGet('colors.text-secondary')};
    }

    ${GraphicBlock} {
      &:first-of-type {
        margin-top: 40px;
      }

      &:last-of-type {
        margin-bottom: 40px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;

    /* Subtitle */
    h1:nth-child(2n),
    h2:nth-child(2n),
    h3:nth-child(2n),
    h4:nth-child(2n),
    h5:nth-child(2n),
    h6:nth-child(2n) {
      font-size: 22px;
      line-height: 38px;
    }

    ${Wrapper}.large-image & {
      ${GraphicBlock} {
        &:first-of-type {
          margin-top: 40px;
        }

        &:last-of-type {
          margin-bottom: 40px;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;

    ${Wrapper}.large-image & {
      padding: 70px 0px 90px;

      ${GraphicBlock} {
        &:first-of-type {
          margin-top: 48px;
        }

        &:last-of-type {
          margin-bottom: 48px;
        }
      }
    }

    ${Wrapper}.single-item & {
      padding: 70px 45px 90px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;

    ${Wrapper}.large-image & {
      padding: 70px 45px 90px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;

    ${Wrapper}.large-image & {
      padding: 70px 90px 90px;
    }

    ${Wrapper}.single-item & {
      padding: 70px 90px 90px;
    }
  }
`;

export const StyledLink = styled(Link)`
  align-self: center;
`;
